export default __webpack_public_path__ + "static/media/Asad Waleed.686f3a0e.jpg";